const KEY = 'dnd5.lastRead';

export type LastRead = {bookId: string; chapterId: string; bookTitle: string; chapterTitle: string};

export function readLastRead(): LastRead | null {
	try {
		const value = JSON.parse(localStorage.getItem(KEY) || 'null');
		return value?.bookId && value?.chapterId ? value : null;
	} catch {
		return null;
	}
}

export function saveLastRead(value: LastRead) {
	try {
		localStorage.setItem(KEY, JSON.stringify(value));
	} catch {
		return;
	}
}
